import React, {Component, useState} from 'react'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import FadeIn from 'react-fade-in';

import styled from "styled-components";
import HomeHeader from "../header/HomeHeader";
import FooterMainView from "../footer/FooterMainView";
import ContactView from "../ContactView";  

import PageTitle from "../common/PageTitle";
import DeviceUtils from "../../../helper/DeviceUtils";


const Centeryellow =  styled.div` 
    color:white;
    padding-top: ${props => props.paddingTop}px;
    background-color: #4890cb;
    height: ${props => props.height}px;
    position: relative;  `;

const H4div =  styled.span`
    font-size: ${props => props.fontSize}px ;
        line-height:1em;  `;


const ContactusPage = () => {



    //中央內容高
    const mainHeight = window.innerHeight - 137 - 200;
    const EXPERT_margin_top = (mainHeight - 325)/2;

    const isValidEmailAddress = (address)=> {
        return !! address.match(/.+@.+/);
    }

    return <div id={"ContactusPage"} className="overflow-hidden"  style={{backgroundColor: '#000000'}}  >

        <HomeHeader/>
   
        <FadeIn>  
            <PageTitle title="GET IN TOUCH" />
 
            <div style={{ 
                                paddingLeft:`${DeviceUtils.isMobile()===true?0:65}px`
                        }}> 
                        <ContactView type="Contactus"/>
            </div> 
            
            <FooterMainView />
            
        </FadeIn>

    </div>;
};


export default ContactusPage;



// WEBPACK FOOTER //
// ./src/components/homepage_new/contactus/ContactusPage.js